import { render, staticRenderFns } from "./DetailPemutakhiranJumlahPenerbitanIzin.vue?vue&type=template&id=70072aaa&"
import script from "./DetailPemutakhiranJumlahPenerbitanIzin.vue?vue&type=script&lang=js&"
export * from "./DetailPemutakhiranJumlahPenerbitanIzin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports